export default "__VITE_ASSET__rnMtVX4S__"